// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "dist/" + "main" + "." + "b92743d04934107a76cf" + ".css";
};